import { ModuleConfig } from "../../common/types";
import ChatIcon from "@mui/icons-material/Chat";
import DescriptionIcon from "@mui/icons-material/Description";

export const config: ModuleConfig = {
  id: "ida",
  name: "Intelligent Document Agent",
  description: "Chat with your documents using AI — upload files and ask questions to extract insights.",
  startPage: "chat", // Default page for IDA module
  routes: [
    {
      path: "chat",
      componentPath: "./modules/ida/views/Chat",
      requiredRole: "user",
    },
    {
      path: "documents",
      componentPath: "./modules/ida/views/Documents",
      requiredRole: "user",
    },
  ],
  navigation: [
    {
      path: "chat",
      name: "Chat",
      icon: ChatIcon,
      requiredRole: "user",
    },
    {
      path: "documents",
      name: "Documents",
      icon: DescriptionIcon,
      requiredRole: "user",
    },
  ],
};
